/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupportRewardLedgerEntry
 */
export interface SupportRewardLedgerEntry {
    /**
     * 
     * @type {number}
     * @memberof SupportRewardLedgerEntry
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SupportRewardLedgerEntry
     */
    transactionType: string;
    /**
     * 
     * @type {number}
     * @memberof SupportRewardLedgerEntry
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof SupportRewardLedgerEntry
     */
    currency: string;
    /**
     * 
     * @type {boolean}
     * @memberof SupportRewardLedgerEntry
     */
    pending: boolean;
    /**
     * 
     * @type {number}
     * @memberof SupportRewardLedgerEntry
     */
    bookingId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SupportRewardLedgerEntry
     */
    referredUserId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SupportRewardLedgerEntry
     */
    referredBookingId?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof SupportRewardLedgerEntry
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof SupportRewardLedgerEntry
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the SupportRewardLedgerEntry interface.
 */
export function instanceOfSupportRewardLedgerEntry(value: object): value is SupportRewardLedgerEntry {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('transactionType' in value) || value['transactionType'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('pending' in value) || value['pending'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function SupportRewardLedgerEntryFromJSON(json: any): SupportRewardLedgerEntry {
    return SupportRewardLedgerEntryFromJSONTyped(json, false);
}

export function SupportRewardLedgerEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupportRewardLedgerEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'transactionType': json['transaction_type'],
        'amount': json['amount'],
        'currency': json['currency'],
        'pending': json['pending'],
        'bookingId': json['booking_id'] == null ? undefined : json['booking_id'],
        'referredUserId': json['referred_user_id'] == null ? undefined : json['referred_user_id'],
        'referredBookingId': json['referred_booking_id'] == null ? undefined : json['referred_booking_id'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

export function SupportRewardLedgerEntryToJSON(json: any): SupportRewardLedgerEntry {
    return SupportRewardLedgerEntryToJSONTyped(json, false);
}

export function SupportRewardLedgerEntryToJSONTyped(value?: SupportRewardLedgerEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'transaction_type': value['transactionType'],
        'amount': value['amount'],
        'currency': value['currency'],
        'pending': value['pending'],
        'booking_id': value['bookingId'],
        'referred_user_id': value['referredUserId'],
        'referred_booking_id': value['referredBookingId'],
        'created_at': value['createdAt'].toISOString(),
        'updated_at': value['updatedAt'].toISOString(),
    };
}

